import { useState, useEffect } from 'react';
import { reverseGeocode, placeToAreaCity } from '../api/addressSearchService';
import { getAccuratePosition } from '../utils/geolocation';

/** Detect browser location and reverse geocode to get area_city. Returns city string or undefined. */
export function useLocationAreaCity(): string | undefined {
  const [areaCity, setAreaCity] = useState<string | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const position = await getAccuratePosition({ timeout: 10000 });
        const place = await reverseGeocode(position.coords.latitude, position.coords.longitude);
        const city = placeToAreaCity(place);
        if (city && !cancelled) setAreaCity(city);
      } catch {
        // Silent fail - areaCity stays undefined
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return areaCity;
}
